import { unsubscribeRequest } from 'api/unsubscibe';
import classNames from 'classnames';
import { Spinner } from 'components/Spinner';
import { useOTSTranslation } from 'i18n/useOTSTranslation';
import { IBackgroundImages } from 'api/home/types';
import { useCallback } from 'react';
import { useMutation } from 'react-query';
import styles from './styles.module.scss';

export const HeroUnsubscribe = ({
  backgroundImage, loading, email, subid,
}: {
  email: string, subid: string
  backgroundImage?: IBackgroundImages, loading?: boolean
}) => {
  const { t } = useOTSTranslation('common');

  const {
    isLoading, data, error, mutate,
  } = useMutation('unsubscribe', () => unsubscribeRequest(subid as string, email as string));

  const unsubscribeCb = useCallback(() => {
    mutate();
  }, [mutate]);

  return (
    <div>
      <header className={styles.photo} style={!loading ? { backgroundImage: `url("${backgroundImage?.image}"` } : {}}>
        <div className={styles.background} />
        <div className={classNames('container', styles.container)}>
          {!isLoading && !!error && (
            <div style={{ textAlign: 'center' }}>
              <h1 className={styles.title}>{t('email.error.text')}</h1>
              <button
                type="submit"
                className={styles.btnSearch}
                onClick={unsubscribeCb}
              >
                {t('email.unsubscribe.message')}
              </button>
            </div>
          )}
          {isLoading && (
            <div style={{ textAlign: 'center' }}>
              <Spinner />
            </div>
          )}
          {!isLoading && data && (
            <div style={{ textAlign: 'center' }}>
              <h1 className={styles.title}>{t('email.unsubscribe.text')}</h1>
            </div>
          )}
          {!isLoading && !error && !data && (
            <div style={{ textAlign: 'center' }}>
              <button
                type="submit"
                className={styles.btnSearch}
                onClick={unsubscribeCb}
              >
                {t('email.unsubscribe.message')}
              </button>
            </div>
          )}
        </div>
      </header>
    </div>
  );
};
